// Function to format timestamps to readable date
const formatDate = (timestamp) => {
	if (!timestamp) return 'N/A'
	return new Date(timestamp).toLocaleString()
}

export default formatDate
